import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AnimationService } from 'src/app/utils/animation.service';

@Component({
  selector: 'app-introduction',
  templateUrl: './introduction.component.html',
  styleUrls: ['../home.component.scss', './introduction.component.scss']
})
export class IntroductionComponent implements OnInit {
  
  @ViewChild('animation')
  animation: ElementRef;

  constructor(private animations: AnimationService, private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.route.fragment.subscribe(params => {
      if (params === 'program') {
        const element = document.querySelector('#program');
        const headerHeight = document.getElementById('header').offsetHeight;
        if (element) {
          setTimeout(()=>{
            window.scrollTo({
              behavior: 'smooth',
              top: document.getElementById('program').offsetTop - headerHeight - 30
            });
          }, 500);
        }
      }
    });
  }

  @HostListener('window:scroll', ['$event'])
  onWindowScroll(event) {
    this.animations.startRightToLeftAnimation(this.animation.nativeElement);
  }
}
